import PageLayout from '@/components/shared/PageLayout';
import SettingsContent from "./SettingsContent";

export default function SettingsPage() {
  return (
    <PageLayout
      title="Settings"
      subtitle="Manage your account preferences and app settings"
    >
      <SettingsContent />
    </PageLayout>
  );
}



